"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AlarmFunction_1 = require("./AlarmFunction");
var lodash_1 = require("lodash");
var Alarms = /** @class */ (function () {
    function Alarms() {
    }
    Alarms.fromJson = function (json) {
        if (!json) {
            return undefined;
        }
        var alarms = new Alarms();
        var path = "#/properties/alarms";
        alarms.sceAlarms = lodash_1.map(Object.keys(json), function (functionName) {
            var alarmFunction = AlarmFunction_1.AlarmFunction.fromJson(functionName, path, json[functionName]);
            return alarmFunction;
        });
        return alarms;
    };
    Alarms.prototype.toJson = function (includeOnlyVariableData) {
        var json = Object.create(null);
        lodash_1.map(this.sceAlarms, function (sceAlarm) {
            json = Object.assign(json, sceAlarm.toJson(includeOnlyVariableData));
        });
        return json;
    };
    Alarms.prototype.getAlarmConditionVariable = function (functionName, conditionName) {
        var alarmFunction = lodash_1.find(this.sceAlarms, function (sceAlarm) { return sceAlarm.functionName === functionName; });
        if (!alarmFunction) {
            return undefined;
        }
        var variable = alarmFunction.getAlarmConditionVariable(conditionName);
        return variable;
    };
    return Alarms;
}());
exports.Alarms = Alarms;
//# sourceMappingURL=Alarms.js.map